module.exports = __webpack_public_path__ + "static/media/f_eyeshape_monolid_darkbrown.b5723527.png";